import { RouteLocationNormalized } from "vue-router"

export default (to: RouteLocationNormalized): boolean | undefined => {
  const isEnabled = process.env.VUE_APP_USE_NEXUS_CARD_PAYMENT_PAGE === "true"
  if (!isEnabled) return

  if (to.name !== "make-payment") return

  let redirectUrl = new URL(window.location.href)

  const isDevelopment = process.env.NODE_ENV === "development"
  if (isDevelopment) {
    const queryString = window.location.search || ""
    const myaccountHostUrl = process.env.VUE_APP_ACCOUNT_APP_URL
    redirectUrl = new URL(`${myaccountHostUrl}${queryString}`)
  }

  redirectUrl.pathname = "/myaccount/payments/new"
  window.location.assign(redirectUrl.toString())
  return false
}
